module.exports = __webpack_public_path__ + "static/media/operating-billboard.195127ab.svg";